export const formatForExcel2 = (data) => {
  const aoa = [];

  data.forEach((invoice) => {
    // Add Invoice Header
    const invoiceHeader = ["Invoice Date", "Invoice Amount", "Invoice Number", "PO Number", "Vendor Name"];
    aoa.push(invoiceHeader);

    // Add Invoice Row
    aoa.push([
      invoice.INVOICE_DATE || "",
      invoice.INV_INVOICE_AMOUNT || "",
      invoice.INV_INVOICE_NUMBER || "",
      invoice.PO_NUMBER || "",
      invoice.VENDOR_NAME || "",
    ]);

    const payments = invoice.PAYMENT_LIST || [];

    if (
      !payments.length ||
      payments.every((p) => !p.PAYMENT_MODE || p.PAYMENT_MODE === "No Payment Info")
    ) {
      // Only Payment Mode + No Payment Info
      aoa.push(["", "", "", "", "Payment Mode"]);
      aoa.push(["", "", "", "", "No Payment Info"]);
    } else {
      // Add Payment Header Row
      aoa.push(["", "", "", "",
        "Payment Mode",
        "Pay Amount",
        "Accounting Date",
        "Payment Date",
        "Payment Number"
      ]);

      // Add Each Payment Row
      payments.forEach((p) => {
        aoa.push(["", "", "", "",
          p.PAYMENT_MODE || "",
          p.PAY_AMOUNT || "",
          p.ACCOUNTING_DATE || "",
          p.CHEQUE_DATE || "",
          p.CHEQUE_NUMBER || "",
        ]);
      });
    }

    // Spacer
    aoa.push([]);
  });

  return aoa;
};
